var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamMemberProfi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59063 1.72597L10.7051 3.8405C10.9658 4.1012 10.9658 4.52388 10.7052 4.78459L5.39758 10.0924C5.31302 10.1769 5.2073 10.2372 5.09147 10.2669L2.24714 10.9968C1.75548 11.123 1.30848 10.676 1.43463 10.1843L2.16445 7.33989C2.19417 7.22405 2.25446 7.11833 2.33902 7.03377L7.6466 1.72598C7.90728 1.46528 8.32994 1.46528 8.59063 1.72597ZM8.11862 2.38683L2.93128 7.57438L2.26663 10.1648L4.85699 9.50009L10.0443 4.31255L8.11862 2.38683Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30815 4.12508C8.41243 4.22936 8.41243 4.39842 8.30815 4.5027L5.10403 7.70695C4.99975 7.81123 4.83069 7.81124 4.72641 7.70696C4.62213 7.60268 4.62212 7.43362 4.7264 7.32934L7.93052 4.12509C8.0348 4.02081 8.20387 4.0208 8.30815 4.12508Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65829 8.39656C3.76257 8.29229 3.93164 8.29229 4.03591 8.39657L5.10396 9.46465C5.20823 9.56893 5.20823 9.738 5.10395 9.84228C4.99967 9.94656 4.8306 9.94655 4.72632 9.84227L3.65828 8.77419C3.55401 8.66991 3.55401 8.50084 3.65829 8.39656Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26038 0.46887C9.41681 0.312456 9.67041 0.312461 9.82682 0.468881L11.9629 2.60505C12.1193 2.76147 12.1193 3.01507 11.9629 3.17148C11.8065 3.3279 11.5529 3.32789 11.3965 3.17147L9.26037 1.03531C9.10396 0.878886 9.10396 0.625284 9.26038 0.46887Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMemberProfi);
export default __webpack_public_path__ + "static/media/teamMemberProfi.644c437e4f82e0ec20d49f1e897dbde1.svg";
export { ForwardRef as ReactComponent };